import { Menu, Divider } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, iRootState } from '../../redux/store';
import AttachmentMenuItem from './AttachmentMenuItem';
import DownloadAllButton from './DownloadAllButton';
import cleanFileName from '../../cleanFileName';
import quotesBaseUrl from '../../quotesBaseUrl';

const AttachmentsMenu = function AttachmentsMenu(): React.ReactElement {
  const dispatch = useDispatch<Dispatch>();
  const open = useSelector((state: iRootState) => state.attachmentsMenu.open);
  const title = useSelector((state: iRootState) => state.quote.title);
  const quoteId = useSelector((state: iRootState) => state.quote.id);
  const anchorEl = useSelector(
    (state: iRootState) => state.attachmentsMenu.anchorEl
  );
  const attachments = useSelector(
    (state: iRootState) => state.quote.attachments
  );

  const projectName = useSelector(
    (state: iRootState) => state.quote.projectName
  );
  const zipFileName = useSelector(
    (state: iRootState) => state.quote.zipFileName
  );

  const baseURL = quotesBaseUrl();
  const quotePDFAttachment: string[] = [];
  const otherAttachments: string[] = [];
  attachments.forEach(attachment =>
    attachment.toLowerCase() === 'quote.pdf'
      ? quotePDFAttachment.push(attachment)
      : otherAttachments.push(attachment)
  );

  const createMenuItem = function createMenuItem(
    text: string,
    link: string,
    i: number
  ): React.ReactElement {
    return (
      <AttachmentMenuItem
        key={`${text}${i}`}
        attachmentTitle={text}
        attachmentLink={link}
      />
    );
  };

  const createMenuItemForQuote = function createAttachmentMenuItemFromQuote(
    attachment: string,
    i: number
  ): React.ReactElement {
    const text = `${projectName} (${title})`;
    const link = `${baseURL}/${quoteId}/quote.pdf`;
    return createMenuItem(text, link, i);
  };

  const createMenuItemForAttachment = function createAttachmentMenuItemFromAttachment(
    attachment: string,
    i: number
  ): React.ReactElement {
    const link = `${baseURL}/${quoteId}/${cleanFileName(attachment)}.pdf`;
    return createMenuItem(attachment, link, i);
  };

  return (
    <Menu
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      onClose={dispatch.attachmentsMenu.toggleOpen}
    >
      {quotePDFAttachment && quotePDFAttachment.map(createMenuItemForQuote)}
      {quotePDFAttachment && otherAttachments && <Divider />}
      {otherAttachments && otherAttachments.map(createMenuItemForAttachment)}
      {zipFileName && <DownloadAllButton />}
    </Menu>
  );
};

export default AttachmentsMenu;
